<template>
    <div>
        <div class="row">
            <div class="col">
                <app-select id="make_id"
                            v-model="form.make_id"
                            :options="makes.map(c => c.id)"
                            name="make_id"
                            rules="required"
                            searchable
                            not-empty
                            closeOnSelect
                            :custom-label="id => makes.some(c => c.id === id) ? makes.find(c => c.id === id).name : null"
                            @select="getModels($event)">
                    <template #label>
                        {{ $t('Make') }}*
                    </template>
                </app-select>
            </div>
            <div class="col">
                <app-select id="model_id"
                            v-model="form.model_id"
                            :options="models.map(c => c.id)"
                            name="model_id"
                            rules="required"
                            searchable
                            not-empty
                            closeOnSelect
                            :custom-label="id => models.some(c => c.id === id) ? models.find(c => c.id === id).name : null">
                    <template #label>
                        {{ $t('Model') }}*
                    </template>
                </app-select>
            </div>
            <div class="col">
                <app-input id="reg_no" v-model="form.reg_no" name="reg_no" rules="required">
                    <template #label>
                        {{ $t('Reg no') }}*
                    </template>
                </app-input>
            </div>
            <div class="col">
                <app-input id="year" v-model="form.year" type="number" name="year" rules="required">
                    <template #label>
                        {{ $t('Year') }}*
                    </template>
                </app-input>
            </div>
            <div class="col">
                <app-input id="user_year" v-model="form.user_year" name="user_year" rules="required">
                    <template #label>
                        {{ $t('Year') }}*
                    </template>
                </app-input>
            </div>
            <div class="col">
                <app-input v-if="form.slug" id="slug" v-model="form.slug" name="slug">
                    <template #label>
                        Url
                    </template>
                </app-input>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <app-input id="vin" v-model="form.vin" name="vin" rules="required">
                    <template #label>
                        {{ $t('VIN') }}*
                    </template>
                </app-input>
            </div>
            <div class="col">
                <app-select id="drivetrain_id"
                            v-model="form.drivetrain_id"
                            :options="params.drivetrains.map(c => c.id)"
                            name="drivetrain_id"
                            rules="required"
                            searchable
                            not-empty
                            closeOnSelect
                            :custom-label="id => params.drivetrains.some(c => c.id === id) ? $t(params.drivetrains.find(c => c.id === id).name) : null">
                    <template #label>
                        {{ $t('Drivetrain') }}*
                    </template>
                </app-select>
            </div>
            <div class="col">
                <app-select id="type_id"
                            v-model="form.type_id"
                            :options="params.types.map(c => c.id)"
                            name="type_id"
                            rules="required"
                            searchable
                            not-empty
                            closeOnSelect
                            :custom-label="id => params.types.some(c => c.id === id) ? $t(params.types.find(c => c.id === id).name) : null">
                    <template #label>
                        {{ $t('Type') }}*
                    </template>
                </app-select>
            </div>
            <div class="col">
                <app-select id="fuel_id"
                            v-model="form.fuel_id"
                            :options="params.fuels.map(c => c.id)"
                            name="fuel_id"
                            rules="required"
                            searchable
                            not-empty
                            closeOnSelect
                            :custom-label="id => params.fuels.some(c => c.id === id) ? $t(params.fuels.find(c => c.id === id).name) : null">
                    <template #label>
                        {{ $t('Fuel') }}*
                    </template>
                </app-select>
            </div>
            <div class="col">
                <app-select id="transmission_id"
                            v-model="form.transmission_id"
                            :options="params.transmissions.map(c => c.id)"
                            name="transmission_id"
                            rules="required"
                            searchable
                            not-empty
                            closeOnSelect
                            :custom-label="id => params.transmissions.some(c => c.id === id) ? $t(params.transmissions.find(c => c.id === id).name) : null">
                    <template #label>
                        {{ $t('Transmission') }}*
                    </template>
                </app-select>
            </div>
            <div class="col">
                <app-multi-lang-input id="color"
                                      v-model="form.color"
                                      name="color"
                                      rules="required"
                                      :langs="locales && Object.keys(locales)">
                    <template #label>
                        {{ $t('Color') }}*
                    </template>
                </app-multi-lang-input>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <app-select id="group_id"
                            v-model="form.group_id"
                            :options="params.groups.map(c => c.id)"
                            name="group_id"
                            rules="required"
                            searchable
                            not-empty
                            closeOnSelect
                            can-add-new
                            @addnew="addNewGroup"
                            :custom-label="id => params.groups.some(c => c.id === id) ? params.groups.find(c => c.id === id).name[locale] : null">
                    <template #label>
                        {{ $t('Group') }}*
                    </template>
                </app-select>
            </div>
            <div class="col">
                <app-multi-lang-input id="body_type"
                                      v-model="form.body_type"
                                      name="body_type"
                                      rules="required"
                                      :langs="locales && Object.keys(locales)">
                    <template #label>
                        {{ $t('Body type') }}*
                    </template>
                </app-multi-lang-input>
            </div>
            <div class="col">
                <app-input id="engine" v-model="form.engine" name="engine" rules="required">
                    <template #label>
                        {{ $t('Engine') }}*
                    </template>
                </app-input>
            </div>
            <div class="col">
                <app-input id="odometer" v-model="form.odometer" type="number" name="odometer" rules="required">
                    <template #label>
                        {{ $t('Odometer') }}*
                    </template>
                </app-input>
            </div>
            <div class="col">
                <app-input id="liability_sum" v-model="form.liability_sum" type="number" name="liability_sum" rules="required">
                    <template #label>
                        {{ $t('Liability') }}*
                    </template>
                </app-input>
            </div>
            <div class="col">
                <app-input id="bond" v-model="form.bond" type="number" name="bond" rules="required">
                    <template #label>
                        {{ $t('Bond') }}*
                    </template>
                </app-input>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <app-multi-lang-textarea id="equipment"
                                         v-model="form.equipment"
                                         name="equipment"
                                         :langs="locales && Object.keys(locales)">
                    <template #label>
                        {{ $t('Equipment') }}
                    </template>
                </app-multi-lang-textarea>
            </div>
            <div class="col">
                <app-multi-lang-textarea id="damages"
                                         v-model="form.damages"
                                         name="damages"
                                         :langs="locales && Object.keys(locales)">
                    <template #label>
                        {{ $t('Damages') }}
                    </template>
                </app-multi-lang-textarea>
            </div>
            <div class="col">
                <app-textarea id="comments" v-model="form.comments" name="comments">
                    <template #label>
                        {{ $t('Comments') }} {{ $t('(in house)') }}
                    </template>
                </app-textarea>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <app-upload input-class="form-control custom-green-input-bg"
                            :max-size="maxMbSize"
                            :placeholder="$t('Click here to choose files')"
                            multiple
                            @size-exceeded="onSizeExceeded"
                            @remove="removeFile"
                            @files="onFiles"/>
            </div>
        </div>
        <create-modal @setGroup="setGroup"/>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import VehicleService from '@services/vehicle.service';
import CreateModal from '@views/Admin/Settings/tabs/VehicleGroups/modals/Create';

export default {
    name: 'VehicleForm',
    props: {
        form: Object
    },
    data() {
        return {
            params: {
                types: [],
                fuels: [],
                transmissions: [],
                drivetrains: [],
                groups: []
            },
            makes: [],
            models: [],
            maxMbSize: 10
        };
    },
    computed: {
        ...mapGetters(['locale', 'locales']),
        makeId() {
            return this.form.make_id;
        }
    },
    watch: {
        makeId(newVal) {
            if (newVal == null || typeof newVal == undefined) {
                return;
            }

            this.getModels(this.form.make_id);
        }
    },
    methods: {
        setGroup(group) {
            this.params.groups.push(group);
        },
        addNewGroup() {
            this.$modal.show('create_group');
        },
        onFiles(files) {
            this.form.images = files;
        },
        onSizeExceeded(size) {
            alert(`${this.$t('File size')} ${Math.round((size + Number.EPSILON) * 100) / 100}Mb ${this.$t('exceeds the limit of')} ${this.maxMbSize}Mb!`);
        },
        removeFile(index) {
            this.form.images.splice(index, 1);
        },
        getParams(){
            VehicleService.params().then(res => this.params = res);
        },
        getMakes(){
            VehicleService.makes().then(res => this.makes = res);
        },
        getModels(makeId){
            VehicleService.models(makeId).then(res => this.models = res);
        }
    },
    components: {
        CreateModal
    },
    created() {
        this.getParams();
        this.getMakes();
    }
};
</script>
